import { createEntityAdapter } from '@reduxjs/toolkit'
import { IAttributeGroup } from '../../types'

export const attributeGroupsAdapter = createEntityAdapter<IAttributeGroup>()